// extracted by mini-css-extract-plugin
var _1 = "MagneticWallItem-module__actionContainer--yz9jv";
var _2 = "MagneticWallItem-module__active--HoO43";
var _3 = "MagneticWallItem-module__animateUploadProgressBarWidth--XPXen";
var _4 = "MagneticWallItem-module__animatedBackground--RK74g";
var _5 = "MagneticWallItem-module__avatar--ejPia";
var _6 = "MagneticWallItem-module__avatarContainer--N6yZv";
var _7 = "MagneticWallItem-module__avatarContainerDisabled--qPWcT";
var _8 = "MagneticWallItem-module__buttonGroup--lStoV";
var _9 = "MagneticWallItem-module__card--okHTL";
var _a = "MagneticWallItem-module__compactContainer--RHS3W";
var _b = "MagneticWallItem-module__focusable--D5oVE";
var _c = "MagneticWallItem-module__focused--b61IE";
var _d = "MagneticWallItem-module__fullContainer--wsRyc";
var _e = "MagneticWallItem-module__iconButton--XSVGT";
var _f = "MagneticWallItem-module__inner--_5IAN";
var _10 = "MagneticWallItem-module__item--zUxeS";
var _11 = "MagneticWallItem-module__minWidthDisabled--wn5Ul";
var _12 = "MagneticWallItem-module__overlapped--cAeG3";
var _13 = "MagneticWallItem-module__popOverContainer--tEEB1";
var _14 = "MagneticWallItem-module__sideTop--xeT38";
var _15 = "MagneticWallItem-module__wideContainer--vMrlL";
export { _1 as "actionContainer", _2 as "active", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "avatar", _6 as "avatarContainer", _7 as "avatarContainerDisabled", _8 as "buttonGroup", _9 as "card", _a as "compactContainer", _b as "focusable", _c as "focused", _d as "fullContainer", _e as "iconButton", _f as "inner", _10 as "item", _11 as "minWidthDisabled", _12 as "overlapped", _13 as "popOverContainer", _14 as "sideTop", _15 as "wideContainer" }
